import { render } from "./PodcasterOverview.vue?vue&type=template&id=397654a1&scoped=true"
import script from "./PodcasterOverview.vue?vue&type=script&lang=js"
export * from "./PodcasterOverview.vue?vue&type=script&lang=js"

import "./PodcasterOverview.vue?vue&type=style&index=0&id=397654a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397654a1"]])

export default __exports__